<div class="agenda-container">
  <div class="container-fluid mt-4">
    <div class="row mb-4">
      <div class="col-md-12">
        <!-- Header -->
        <div class="page-header">
          <div>
            <h2><i class="bi bi-calendar-event me-2"></i>Agenda</h2>
            <p class="text-muted mb-0">Gerencie agendamentos e horários dos seus pacientes</p>
          </div>
          <button class="btn btn-primary btn-sm" (click)="openNewAppointmentModal()">
            <i class="bi bi-plus-lg me-1"></i> Novo Agendamento
          </button>
        </div>
        <hr/>
      </div>
    </div>

    <!-- Calendário -->
    <div class="row">
      <div class="col-md-8">
        <div class="card calendar-card">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <button class="btn btn-sm btn-outline-secondary" (click)="previousMonth()">
                <i class="bi bi-chevron-left"></i>
              </button>
              <h5 class="mb-0">{{ getMonthYear() | titlecase }}</h5>
              <button class="btn btn-sm btn-outline-secondary" (click)="nextMonth()">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <!-- Dias da semana -->
            <div class="calendar-weekdays">
              <div *ngFor="let day of weekDays" class="calendar-weekday">{{ day }}</div>
            </div>

            <!-- Dias do mês -->
            <div class="calendar-days" [class.loading-dimmed]="loading">
              <div
                *ngFor="let date of calendarDays"
                class="calendar-day"
                [class.other-month]="!isCurrentMonth(date)"
                [class.today]="isToday(date)"
                [class.selected]="isSelected(date)"
                (click)="selectDate(date)">
                <div class="day-number">{{ date.getDate() }}</div>
                <div class="day-appointments">
                  <div *ngFor="let apt of getAppointmentsForDate(date)"
                       class="appointment-dot"
                       [class.confirmed]="apt.isConfirmed"
                       [title]="apt.patient?.name || 'Agendamento'">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Agendamentos do dia -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h6 class="mb-0">{{ formatDate(selectedDate) }}</h6>
          </div>
          <div class="card-body appointments-list">
            <div *ngIf="getAppointmentsForSelectedDate().length === 0" class="text-center text-muted py-4">
              Nenhum agendamento para este dia
            </div>

            <div *ngFor="let apt of getAppointmentsForSelectedDate()"
                 class="appointment-item"
                 (click)="viewAppointmentDetails(apt)">
              <div class="appointment-time">{{ formatTime(apt.startTime) }}</div>
              <div class="appointment-patient">{{ apt.patient?.name || 'Paciente' }}</div>
              <div class="appointment-service">{{ apt.serviceType || 'Consulta' }}</div>
              <span [class]="getStatusClass(apt.status)">
                {{ statusLabels[apt.status] }}
              </span>
            </div>
          </div>
        </div>

        <!-- Horários disponíveis -->
        <div class="card mt-3" *ngIf="viewMode === 'day' && availableSlots.length > 0">
          <div class="card-header">
            <h6 class="mb-0">Horários Disponíveis</h6>
          </div>
          <div class="card-body">
            <div class="available-slots">
              <button
                *ngFor="let slot of availableSlots"
                class="btn btn-outline-primary btn-sm me-2 mb-2"
                (click)="openNewAppointmentModal(slot)">
                {{ formatTime(slot.startTime) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================================================
     MODAL — NOVO AGENDAMENTO
     ============================================================ -->
<div class="modal-overlay" *ngIf="showNewAppointmentModal" (click)="closeNewAppointmentModal()"></div>
<div class="modal-wrap" *ngIf="showNewAppointmentModal">
  <div class="modal-box">
    <div class="modal-box-header">
      <h5>Novo Agendamento</h5>
      <button class="btn-x" (click)="closeNewAppointmentModal()">✕</button>
    </div>
    <div class="modal-box-body">

      <div class="mb-3">
        <label class="form-label">Paciente *</label>
        <select class="form-select" [(ngModel)]="newAppointment.patientId">
          <option [ngValue]="0">Selecione um paciente...</option>
          <option *ngFor="let patient of patients" [ngValue]="patient.id">
            {{ patient.name }}
          </option>
        </select>
        <small class="text-muted" *ngIf="patients.length === 0">
          Nenhum paciente cadastrado para este profissional.
        </small>
      </div>

      <div class="mb-3">
        <label class="form-label">Data *</label>
        <div class="date-input-wrapper">
          <input #dateInput type="text" class="form-control"
                 [(ngModel)]="modalDateDisplay"
                 (input)="onDateInput($event)"
                 placeholder="dd/MM/yyyy"
                 maxlength="10">
          <button type="button" class="date-picker-btn" (click)="toggleDatePicker()">
            <i class="bi bi-calendar3"></i>
          </button>
        </div>

        <!-- Overlay para fechar ao clicar fora -->
        <div class="datepicker-overlay" *ngIf="showDatePicker" (click)="showDatePicker = false"></div>

        <!-- Datepicker Popup -->
        <div class="datepicker-popup" *ngIf="showDatePicker"
             [style.top]="pickerTop"
             [style.left]="pickerLeft"
             (click)="$event.stopPropagation()">
          <div class="datepicker-header">
            <button type="button" class="btn-nav" (click)="pickerPreviousMonth()">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="datepicker-month">{{ getPickerMonthYear() | titlecase }}</span>
            <button type="button" class="btn-nav" (click)="pickerNextMonth()">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>

          <div class="datepicker-weekdays">
            <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
          </div>

          <div class="datepicker-days">
            <div
              *ngFor="let date of pickerDays"
              class="datepicker-day"
              [class.other-month]="!pickerIsCurrentMonth(date)"
              [class.today]="pickerIsToday(date)"
              [class.selected]="pickerIsSelected(date)"
              (click)="pickerSelectDate(date)">
              {{ date.getDate() }}
            </div>
          </div>

          <div class="datepicker-footer">
            <button type="button" class="btn btn-sm btn-link" (click)="pickerSelectToday()">
              Hoje
            </button>
          </div>
        </div>

        <small class="text-muted">Clique no calendário ou digite no formato: dd/MM/yyyy</small>
      </div>

      <div class="mb-3" *ngIf="modalDate">
        <label class="form-label">Horário Disponível *</label>
        <div *ngIf="modalSlots.length === 0" class="alert alert-warning">
          Nenhum horário disponível para esta data.
        </div>
        <div class="available-slots-grid" *ngIf="modalSlots.length > 0">
          <button
            *ngFor="let slot of modalSlots"
            type="button"
            class="btn btn-sm"
            [class.btn-outline-primary]="selectedSlot !== slot"
            [class.btn-primary]="selectedSlot === slot"
            (click)="selectSlot(slot)">
            {{ formatTime(slot.startTime) }} - {{ formatTime(slot.endTime) }}
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Tipo de Serviço</label>
        <input type="text" class="form-control"
               [(ngModel)]="newAppointment.serviceType"
               placeholder="Ex: Consulta, Avaliação, Retorno">
      </div>

      <div class="mb-3">
        <label class="form-label">Observações</label>
        <textarea class="form-control" rows="3"
                  [(ngModel)]="newAppointment.notes"></textarea>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="checkbox"
               [(ngModel)]="newAppointment.syncWithGoogleCalendar"
               id="syncGoogle">
        <label class="form-check-label" for="syncGoogle">
          Sincronizar com Google Calendar
        </label>
      </div>

    </div>
    <div class="modal-box-footer">
      <button class="btn btn-secondary" (click)="closeNewAppointmentModal()">Cancelar</button>
      <button class="btn btn-primary" (click)="createAppointment()" [disabled]="saving">
        <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
        Agendar
      </button>
    </div>
  </div>
</div>

<!-- ============================================================
     MODAL — DETALHES DO AGENDAMENTO
     ============================================================ -->
<div class="modal-overlay" *ngIf="showDetailsModal" (click)="closeDetailsModal()"></div>
<div class="modal-wrap" *ngIf="showDetailsModal && selectedAppointment">
  <div class="modal-box">
    <div class="modal-box-header">
      <h5>Detalhes do Agendamento</h5>
      <button class="btn-x" (click)="closeDetailsModal()">✕</button>
    </div>
    <div class="modal-box-body">

      <div class="detail-row">
        <strong>Paciente:</strong>
        <span>{{ selectedAppointment.patient?.name || 'Paciente' }}</span>
      </div>
      <div class="detail-row">
        <strong>Data/Hora:</strong>
        <span>{{ formatDate(selectedAppointment.startTime) }} às {{ formatTime(selectedAppointment.startTime) }}</span>
      </div>
      <div class="detail-row">
        <strong>Tipo de Serviço:</strong>
        <span>{{ selectedAppointment.serviceType || 'Não especificado' }}</span>
      </div>
      <div class="detail-row">
        <strong>Status:</strong>
        <span [class]="getStatusClass(selectedAppointment.status)">
          {{ statusLabels[selectedAppointment.status] }}
        </span>
      </div>
      <div class="detail-row" *ngIf="selectedAppointment.notes">
        <strong>Observações:</strong>
        <span>{{ selectedAppointment.notes }}</span>
      </div>
      <div class="detail-row" *ngIf="selectedAppointment.meetLink">
        <strong><i class="bi bi-camera-video-fill text-primary me-1"></i>Google Meet:</strong>
        <a [href]="selectedAppointment.meetLink" target="_blank" rel="noopener"
           class="btn btn-sm btn-outline-primary">
          <i class="bi bi-box-arrow-up-right me-1"></i> Entrar na Reunião
        </a>
      </div>

    </div>
    <div class="modal-box-footer">
      <ng-container *ngIf="canManageStatus &&
                           selectedAppointment.status !== appointmentStatus.Completed &&
                           selectedAppointment.status !== appointmentStatus.Cancelled">
        <button class="btn btn-success me-1" (click)="finishAppointment()" [disabled]="savingStatus">
          <i class="bi bi-check-circle me-1"></i> Finalizado
        </button>
        <button class="btn btn-danger me-1" (click)="cancelAppointment()" [disabled]="savingStatus">
          <i class="bi bi-x-circle me-1"></i> Cancelar Agendamento
        </button>
      </ng-container>
      <button class="btn btn-secondary" (click)="closeDetailsModal()">Fechar</button>
    </div>
  </div>
</div>
